
export default {
  name: 'LogoIconCertificata',
  methods: {
    getLogo (): string {
      return require('@/assets/logo-icon.png')
    }
  }
}
